import React, { useCallback, useMemo } from "react";
import { Checkbox, Col, Radio, Row } from "antd";
import style from "./index.module.scss";
import QuestionOption from "./components/QuestionOption";
import { useLatest } from "react-use";

interface OptionType {
    description: string;
    key: number;
}

interface QuestionOptionsProps {
    type: "checkbox" | "radio";
    value?: OptionType[];
    onChange?: (value: OptionType[]) => void;
    errors?: any[];
}

export default function QuestionOptions({
    type,
    value,
    onChange,
    errors
}: QuestionOptionsProps) {
    // 为了优化性能使用ref
    const latestOptions = useLatest(value || []);

    const checked = useMemo(() => {
        return latestOptions.current.map(item => item.key);
    }, [latestOptions.current]);

    const onDescriptionChange = useCallback(function onDescriptionChange(
        index: number,
        description: string
    ) {
        const newOptions = latestOptions.current.map((option, idx) =>
            index === idx
                ? { ...latestOptions.current[index], description }
                : option
        );
        onChange?.(newOptions);
    },
    []);

    function onSelectChange(e: any) {
        onChange?.(latestOptions.current || []);
    }

    const onRemove = useCallback(function (index: number) {
        const newOptions = latestOptions.current.filter(
            (_, idx) => idx !== index
        );
        onChange?.(newOptions);
    }, []);

    function onAdd() {
        const newOptions = [
            ...latestOptions.current,
            { key: Math.random(), description: "" }
        ];
        onChange?.(newOptions);
    }

    function getOptionsError(key: number) {
        if (!Array.isArray(errors)) return;
        return errors.find(item => item.key === key)?.error;
    }

    const CheckComponent = type === "checkbox" ? Checkbox.Group : Radio.Group;

    return (
        <React.Fragment>
            <CheckComponent
                className={style.root}
                value={type === "checkbox" ? checked : checked[0]}
                onChange={onSelectChange}>
                {latestOptions.current.map((option, index: number) => (
                    <QuestionOption
                        key={option.key}
                        index={index}
                        showRemove={latestOptions.current.length > 2}
                        value={option.description}
                        onChange={onDescriptionChange}
                        onRemove={onRemove}
                        error={getOptionsError(option.key)}
                    />
                ))}
            </CheckComponent>

            {latestOptions.current.length < 26 && (
                <Row gutter={[0, 20]}>
                    <Col span={5} />

                    <Col span={5}>
                        <button
                            type="button"
                            className={style.btnAdd}
                            onClick={onAdd}>
                            添加选项
                        </button>
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
